// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: RTq7Z2H_2r-

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Header from "../../Header"; // plasmic-import: FX7sJMOvuD/component
import NewsLetter from "../../NewsLetter"; // plasmic-import: hz7eRhzEc6/component
import Select from "../../Select"; // plasmic-import: 08sPv7cVboL/component
import ButtonLinkPrimary from "../../ButtonLinkPrimary"; // plasmic-import: 7LtHkXE9e5/component
import ButtonLinkSecondary from "../../ButtonLinkSecondary"; // plasmic-import: wh4j1QDwJ4/component
import TextInput from "../../TextInput"; // plasmic-import: TAzASWLFePH/component
import ResourceCard from "../../ResourceCard"; // plasmic-import: VFfmrmFekX/component
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component
import { AntdModal } from "@plasmicpkgs/antd5/skinny/registerModal"; // plasmic-import: xx93QbkHH5i/codeComponent
import Footer from "../../Footer"; // plasmic-import: WRs9bMrYcz/component
import ResourceModal from "../../ResourceModal"; // plasmic-import: 584n9N-hkl/component
import ResourceModal2 from "../../ResourceModal2"; // plasmic-import: 07P6RC82cGJP/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicExplorePage.module.css"; // plasmic-import: RTq7Z2H_2r-/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: f42r0km3yz4/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: QKCDMAfoLkN/icon
import _3081627JpgAjj7Gy5Eo from "./images/_3081627Jpg.jpg"; // plasmic-import: Ajj7Gy5EO/picture
import croppedImageBusinessmanEyeglassesSittingByTableCafeUsingLaptopComputerjpgDg90DuiG4 from "./images/croppedImageBusinessmanEyeglassesSittingByTableCafeUsingLaptopComputerjpg.jpg"; // plasmic-import: DG90duiG4/picture

createPlasmicElementProxy;

export type PlasmicExplorePage__VariantMembers = {};
export type PlasmicExplorePage__VariantsArgs = {};
type VariantPropType = keyof PlasmicExplorePage__VariantsArgs;
export const PlasmicExplorePage__VariantProps = new Array<VariantPropType>();

export type PlasmicExplorePage__ArgsType = {
  selectTagsInput?: React.ReactNode;
};
type ArgPropType = keyof PlasmicExplorePage__ArgsType;
export const PlasmicExplorePage__ArgProps = new Array<ArgPropType>(
  "selectTagsInput"
);

export type PlasmicExplorePage__OverridesType = {
  explorePage?: p.Flex<"div">;
  header?: p.Flex<typeof Header>;
  titleSection?: p.Flex<"div">;
  fromIdeaToProduct?: p.Flex<"h2">;
  subtitleText?: p.Flex<"div">;
  resourcesSection?: p.Flex<"div">;
  newsLetterMobile?: p.Flex<typeof NewsLetter>;
  resourcesFilterDropdownMenu?: p.Flex<typeof Select>;
  categoriesDropdownMenu?: p.Flex<typeof Select>;
  resourceFiltersSlotElement?: p.Flex<"div">;
  buttonLinkPrimary?: p.Flex<typeof ButtonLinkPrimary>;
  buttonLinkSecondary?: p.Flex<typeof ButtonLinkSecondary>;
  resourceList?: p.Flex<"div">;
  resourceCard?: p.Flex<typeof ResourceCard>;
  signupSection?: p.Flex<"div">;
  signupEmailInput?: p.Flex<"div">;
  signupInput?: p.Flex<"div">;
  signupEmailButton?: p.Flex<typeof Button>;
  feedbackSection?: p.Flex<"div">;
  feedbackButton?: p.Flex<typeof Button>;
  newsLetter?: p.Flex<typeof NewsLetter>;
  bottomNewsLetter?: p.Flex<typeof NewsLetter>;
  feedbackModal?: p.Flex<typeof AntdModal>;
  footer?: p.Flex<typeof Footer>;
  resourceInfoModal?: p.Flex<typeof AntdModal>;
  resourceModal?: p.Flex<typeof ResourceModal>;
  ol?: p.Flex<"ol">;
  resourceModal2?: p.Flex<typeof ResourceModal2>;
};

export interface DefaultExplorePageProps {
  selectTagsInput?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicExplorePage__RenderFunc(props: {
  variants: PlasmicExplorePage__VariantsArgs;
  args: PlasmicExplorePage__ArgsType;
  overrides: PlasmicExplorePage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "resourcesFilterDropdownMenu.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "Popular"
      },
      {
        path: "resourceInfoModal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          hasVariant(globalVariants, "screen", "mobileOnly") ? false : false
      },
      {
        path: "feedbackModal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "categoriesDropdownMenu.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "All Categories"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"explorePage"}
          data-plasmic-override={overrides.explorePage}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.explorePage
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
          />

          <div
            data-plasmic-name={"titleSection"}
            data-plasmic-override={overrides.titleSection}
            className={classNames(projectcss.all, sty.titleSection)}
          >
            <h2
              data-plasmic-name={"fromIdeaToProduct"}
              data-plasmic-override={overrides.fromIdeaToProduct}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.fromIdeaToProduct
              )}
            >
              {"From Idea To Product"}
            </h2>
            <div
              data-plasmic-name={"subtitleText"}
              data-plasmic-override={overrides.subtitleText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.subtitleText
              )}
            >
              <React.Fragment>
                <React.Fragment>
                  {
                    "The ultimate app for aspiring entrepreneurs to quickly find "
                  }
                </React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ fontWeight: 700 }}
                >
                  {"handpicked"}
                </span>
                <React.Fragment>
                  {", top-notch products tailored to their startup needs."}
                </React.Fragment>
              </React.Fragment>
            </div>
            <p.PlasmicImg
              alt={""}
              className={classNames(sty.img__nsFcb)}
              displayHeight={
                hasVariant(globalVariants, "screen", "mobileOnly")
                  ? "206px"
                  : "369px"
              }
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={{
                src: _3081627JpgAjj7Gy5Eo,
                fullWidth: 3000,
                fullHeight: 2000,
                aspectRatio: undefined
              }}
            />
          </div>
          <div
            data-plasmic-name={"resourcesSection"}
            data-plasmic-override={overrides.resourcesSection}
            className={classNames(projectcss.all, sty.resourcesSection)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___6UXwV)}>
              {(
                hasVariant(globalVariants, "screen", "mobileOnly")
                  ? true
                  : false
              ) ? (
                <NewsLetter
                  data-plasmic-name={"newsLetterMobile"}
                  data-plasmic-override={overrides.newsLetterMobile}
                  className={classNames("__wab_instance", sty.newsLetterMobile)}
                />
              ) : null}
              <div className={classNames(projectcss.all, sty.columns__qX2Bs)}>
                <div className={classNames(projectcss.all, sty.column__knt8P)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__z4G1M)}
                  >
                    <Select
                      data-plasmic-name={"resourcesFilterDropdownMenu"}
                      data-plasmic-override={
                        overrides.resourcesFilterDropdownMenu
                      }
                      className={classNames(
                        "__wab_instance",
                        sty.resourcesFilterDropdownMenu
                      )}
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "resourcesFilterDropdownMenu",
                          "value"
                        ])(eventArgs[0]);
                      }}
                      options={(() => {
                        const __composite = [{ value: null, label: null }];
                        __composite["0"]["value"] = "Popular";
                        __composite["0"]["label"] = "Popular";
                        return __composite;
                      })()}
                      value={p.generateStateValueProp($state, [
                        "resourcesFilterDropdownMenu",
                        "value"
                      ])}
                    />

                    <Select
                      data-plasmic-name={"categoriesDropdownMenu"}
                      data-plasmic-override={overrides.categoriesDropdownMenu}
                      className={classNames(
                        "__wab_instance",
                        sty.categoriesDropdownMenu
                      )}
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "categoriesDropdownMenu",
                          "value"
                        ])(eventArgs[0]);
                      }}
                      options={(() => {
                        const __composite = [{ value: null }];
                        __composite["0"]["value"] = "All Categories";
                        return __composite;
                      })()}
                      value={p.generateStateValueProp($state, [
                        "categoriesDropdownMenu",
                        "value"
                      ])}
                    />

                    <div
                      data-plasmic-name={"resourceFiltersSlotElement"}
                      data-plasmic-override={
                        overrides.resourceFiltersSlotElement
                      }
                      className={classNames(
                        projectcss.all,
                        sty.resourceFiltersSlotElement
                      )}
                    >
                      <ButtonLinkPrimary
                        data-plasmic-name={"buttonLinkPrimary"}
                        data-plasmic-override={overrides.buttonLinkPrimary}
                        className={classNames(
                          "__wab_instance",
                          sty.buttonLinkPrimary
                        )}
                      />

                      <ButtonLinkSecondary
                        data-plasmic-name={"buttonLinkSecondary"}
                        data-plasmic-override={overrides.buttonLinkSecondary}
                        className={classNames(
                          "__wab_instance",
                          sty.buttonLinkSecondary
                        )}
                      />
                    </div>
                  </p.Stack>
                </div>
                <div className={classNames(projectcss.all, sty.column__vQr8R)}>
                  {p.renderPlasmicSlot({
                    defaultContents: (
                      <TextInput
                        className={classNames(
                          "__wab_instance",
                          sty.textInput__vfy5M
                        )}
                      />
                    ),

                    value: args.selectTagsInput
                  })}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.columns__voHxy)}>
                <div className={classNames(projectcss.all, sty.column__ltq8K)}>
                  <div
                    data-plasmic-name={"resourceList"}
                    data-plasmic-override={overrides.resourceList}
                    className={classNames(projectcss.all, sty.resourceList)}
                  >
                    <ResourceCard
                      data-plasmic-name={"resourceCard"}
                      data-plasmic-override={overrides.resourceCard}
                      bodyText={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__saLjs
                          )}
                        >
                          {
                            "Brandmark.io provides AI-driven logo design and branding services, enabling users to effortlessly generate unique and professional logos tailored to their preferences without any design experience."
                          }
                        </div>
                      }
                      className={classNames("__wab_instance", sty.resourceCard)}
                      tagsText={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___4BK3
                          )}
                        >
                          {"#logo #early-stage"}
                        </div>
                      }
                      title={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__rUkM
                          )}
                        >
                          {
                            "Brandmark.io: Revolutionizing Logo Design with AI-Powered Creativity"
                          }
                        </div>
                      }
                    />
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.column__mdxmq)}>
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"signupSection"}
                    data-plasmic-override={overrides.signupSection}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.signupSection)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__un04K)}
                    >
                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__us89B
                        )}
                      >
                        <p.Stack
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__aWBta
                          )}
                        >
                          <p.PlasmicImg
                            alt={""}
                            className={classNames(sty.img___33R7I)}
                            displayHeight={"auto"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"80px"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"auto"}
                            loading={"lazy"}
                            src={{
                              src: croppedImageBusinessmanEyeglassesSittingByTableCafeUsingLaptopComputerjpgDg90DuiG4,
                              fullWidth: 5760,
                              fullHeight: 3840,
                              aspectRatio: undefined
                            }}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___3Ujai
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__fYzp9
                              )}
                            >
                              {"Sign Up for Our Newsletter"}
                            </div>
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text___5BkK
                              )}
                            >
                              {
                                "Get the best resources sent directly to your inbox."
                              }
                            </div>
                          </div>
                        </p.Stack>
                      </p.Stack>
                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__os5Bu
                        )}
                      >
                        <p.Stack
                          as={"div"}
                          data-plasmic-name={"signupEmailInput"}
                          data-plasmic-override={overrides.signupEmailInput}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.signupEmailInput
                          )}
                        >
                          <div
                            data-plasmic-name={"signupInput"}
                            data-plasmic-override={overrides.signupInput}
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.signupInput
                            )}
                          >
                            {""}
                          </div>
                        </p.Stack>
                      </p.Stack>
                      <Button
                        data-plasmic-name={"signupEmailButton"}
                        data-plasmic-override={overrides.signupEmailButton}
                        className={classNames(
                          "__wab_instance",
                          sty.signupEmailButton
                        )}
                        color={"blue"}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__jdvqg
                          )}
                        >
                          {"Sign up"}
                        </div>
                      </Button>
                    </p.Stack>
                  </p.Stack>
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"feedbackSection"}
                    data-plasmic-override={overrides.feedbackSection}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.feedbackSection)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__hgvqg)}
                    >
                      <p.Stack
                        as={"div"}
                        hasGap={true}
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__kpf6L
                        )}
                      >
                        <p.Stack
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__e7Yi
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__tydcY
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__kSav2
                              )}
                            >
                              {"Have some feedback for us?"}
                            </div>
                          </div>
                        </p.Stack>
                      </p.Stack>
                      <Button
                        data-plasmic-name={"feedbackButton"}
                        data-plasmic-override={overrides.feedbackButton}
                        className={classNames(
                          "__wab_instance",
                          sty.feedbackButton
                        )}
                        color={"blue"}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__nnGzo
                          )}
                        >
                          {"Let us Know!"}
                        </div>
                      </Button>
                    </p.Stack>
                  </p.Stack>
                  <NewsLetter
                    data-plasmic-name={"newsLetter"}
                    data-plasmic-override={overrides.newsLetter}
                    className={classNames("__wab_instance", sty.newsLetter)}
                  />
                </div>
              </div>
              <NewsLetter
                data-plasmic-name={"bottomNewsLetter"}
                data-plasmic-override={overrides.bottomNewsLetter}
                className={classNames("__wab_instance", sty.bottomNewsLetter)}
                slot={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___6Tibm
                    )}
                  >
                    {"Join our newsletter!"}
                  </div>
                }
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__f3Tum
                  )}
                >
                  {"Want More Resources?"}
                </div>
              </NewsLetter>
            </div>
          </div>
          <AntdModal
            data-plasmic-name={"feedbackModal"}
            data-plasmic-override={overrides.feedbackModal}
            className={classNames("__wab_instance", sty.feedbackModal)}
            defaultStylesClassName={classNames(
              projectcss.root_reset,
              projectcss.plasmic_default_styles,
              projectcss.plasmic_mixins,
              projectcss.plasmic_tokens,
              plasmic_antd_5_hostless_css.plasmic_tokens
            )}
            modalScopeClassName={sty["feedbackModal__modal"]}
            onOpenChange={p.generateStateOnChangeProp($state, [
              "feedbackModal",
              "open"
            ])}
            open={p.generateStateValueProp($state, ["feedbackModal", "open"])}
            title={"Modal title"}
          >
            <div className={classNames(projectcss.all, sty.freeBox___10ODd)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___4ZNgb
                )}
              >
                {"Modal content"}
              </div>
            </div>
          </AntdModal>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />

          <AntdModal
            data-plasmic-name={"resourceInfoModal"}
            data-plasmic-override={overrides.resourceInfoModal}
            className={classNames("__wab_instance", sty.resourceInfoModal)}
            closeButtonClassName={classNames({
              [sty["pcls_ys4ZJqgcZkBu"]]: hasVariant(
                globalVariants,
                "screen",
                "mobileOnly"
              )
            })}
            defaultStylesClassName={classNames(
              projectcss.root_reset,
              projectcss.plasmic_default_styles,
              projectcss.plasmic_mixins,
              projectcss.plasmic_tokens,
              plasmic_antd_5_hostless_css.plasmic_tokens
            )}
            modalScopeClassName={sty["resourceInfoModal__modal"]}
            onOpenChange={p.generateStateOnChangeProp($state, [
              "resourceInfoModal",
              "open"
            ])}
            open={p.generateStateValueProp($state, [
              "resourceInfoModal",
              "open"
            ])}
            title={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__e84We
                )}
              >
                {"Modal title"}
              </div>
            }
          >
            <ResourceModal
              data-plasmic-name={"resourceModal"}
              data-plasmic-override={overrides.resourceModal}
              className={classNames("__wab_instance", sty.resourceModal)}
              resourceClicks2={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__bxAfo
                  )}
                >
                  {"3.2 Clicks"}
                </div>
              }
              resourceDescription={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ldXcj
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>
                      {
                        "Brandmark.io provides AI-driven logo design and branding services, enabling users to effortlessly generate unique and professional logos tailored to their preferences without any design experience.\n\nTop Features:\n"
                      }
                    </React.Fragment>
                    {
                      <ol
                        data-plasmic-name={"ol"}
                        data-plasmic-override={overrides.ol}
                        className={classNames(
                          projectcss.all,
                          projectcss.ol,
                          sty.ol
                        )}
                      >
                        <li
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.li__h1HBd
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"AI-Powered Logo Generation"}
                            </span>
                            <React.Fragment>
                              {
                                ": Brandmark.io uses artificial intelligence and machine learning algorithms to automatically generate logo designs based on user input and preferences.\n"
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </li>
                        <li
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.li__mAlKu
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Customizable Designs"}
                            </span>
                            <React.Fragment>
                              {
                                ": Users can customize the generated logos by adjusting colors, fonts, and layout to match their branding needs."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </li>
                        <li
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.li__m5S4Z
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Logo Export"}
                            </span>
                            <React.Fragment>
                              {
                                ": The platform allows users to download their finalized logo designs in various formats, such as PNG, SVG, and EPS, making them suitable for different use cases and sizes.\n"
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </li>
                      </ol>
                    }
                    <React.Fragment>{"And many more..\n"}</React.Fragment>
                  </React.Fragment>
                </div>
              }
              resourceLink={"https://brandmark.io/"}
              resourceLinkMobile={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___77NB
                  )}
                >
                  {"www.websitelink.com"}
                </div>
              }
            />

            <ResourceModal2
              data-plasmic-name={"resourceModal2"}
              data-plasmic-override={overrides.resourceModal2}
              className={classNames("__wab_instance", sty.resourceModal2)}
              resourceName={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0QOdz
                  )}
                >
                  {"You won't believe what happens next."}
                </div>
              }
            />
          </AntdModal>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  explorePage: [
    "explorePage",
    "header",
    "titleSection",
    "fromIdeaToProduct",
    "subtitleText",
    "resourcesSection",
    "newsLetterMobile",
    "resourcesFilterDropdownMenu",
    "categoriesDropdownMenu",
    "resourceFiltersSlotElement",
    "buttonLinkPrimary",
    "buttonLinkSecondary",
    "resourceList",
    "resourceCard",
    "signupSection",
    "signupEmailInput",
    "signupInput",
    "signupEmailButton",
    "feedbackSection",
    "feedbackButton",
    "newsLetter",
    "bottomNewsLetter",
    "feedbackModal",
    "footer",
    "resourceInfoModal",
    "resourceModal",
    "ol",
    "resourceModal2"
  ],
  header: ["header"],
  titleSection: ["titleSection", "fromIdeaToProduct", "subtitleText"],
  fromIdeaToProduct: ["fromIdeaToProduct"],
  subtitleText: ["subtitleText"],
  resourcesSection: [
    "resourcesSection",
    "newsLetterMobile",
    "resourcesFilterDropdownMenu",
    "categoriesDropdownMenu",
    "resourceFiltersSlotElement",
    "buttonLinkPrimary",
    "buttonLinkSecondary",
    "resourceList",
    "resourceCard",
    "signupSection",
    "signupEmailInput",
    "signupInput",
    "signupEmailButton",
    "feedbackSection",
    "feedbackButton",
    "newsLetter",
    "bottomNewsLetter"
  ],
  newsLetterMobile: ["newsLetterMobile"],
  resourcesFilterDropdownMenu: ["resourcesFilterDropdownMenu"],
  categoriesDropdownMenu: ["categoriesDropdownMenu"],
  resourceFiltersSlotElement: [
    "resourceFiltersSlotElement",
    "buttonLinkPrimary",
    "buttonLinkSecondary"
  ],
  buttonLinkPrimary: ["buttonLinkPrimary"],
  buttonLinkSecondary: ["buttonLinkSecondary"],
  resourceList: ["resourceList", "resourceCard"],
  resourceCard: ["resourceCard"],
  signupSection: [
    "signupSection",
    "signupEmailInput",
    "signupInput",
    "signupEmailButton"
  ],
  signupEmailInput: ["signupEmailInput", "signupInput"],
  signupInput: ["signupInput"],
  signupEmailButton: ["signupEmailButton"],
  feedbackSection: ["feedbackSection", "feedbackButton"],
  feedbackButton: ["feedbackButton"],
  newsLetter: ["newsLetter"],
  bottomNewsLetter: ["bottomNewsLetter"],
  feedbackModal: ["feedbackModal"],
  footer: ["footer"],
  resourceInfoModal: [
    "resourceInfoModal",
    "resourceModal",
    "ol",
    "resourceModal2"
  ],
  resourceModal: ["resourceModal", "ol"],
  ol: ["ol"],
  resourceModal2: ["resourceModal2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  explorePage: "div";
  header: typeof Header;
  titleSection: "div";
  fromIdeaToProduct: "h2";
  subtitleText: "div";
  resourcesSection: "div";
  newsLetterMobile: typeof NewsLetter;
  resourcesFilterDropdownMenu: typeof Select;
  categoriesDropdownMenu: typeof Select;
  resourceFiltersSlotElement: "div";
  buttonLinkPrimary: typeof ButtonLinkPrimary;
  buttonLinkSecondary: typeof ButtonLinkSecondary;
  resourceList: "div";
  resourceCard: typeof ResourceCard;
  signupSection: "div";
  signupEmailInput: "div";
  signupInput: "div";
  signupEmailButton: typeof Button;
  feedbackSection: "div";
  feedbackButton: typeof Button;
  newsLetter: typeof NewsLetter;
  bottomNewsLetter: typeof NewsLetter;
  feedbackModal: typeof AntdModal;
  footer: typeof Footer;
  resourceInfoModal: typeof AntdModal;
  resourceModal: typeof ResourceModal;
  ol: "ol";
  resourceModal2: typeof ResourceModal2;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicExplorePage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicExplorePage__VariantsArgs;
    args?: PlasmicExplorePage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicExplorePage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicExplorePage__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicExplorePage__ArgProps,
          internalVariantPropNames: PlasmicExplorePage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicExplorePage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "explorePage") {
    func.displayName = "PlasmicExplorePage";
  } else {
    func.displayName = `PlasmicExplorePage.${nodeName}`;
  }
  return func;
}

export const PlasmicExplorePage = Object.assign(
  // Top-level PlasmicExplorePage renders the root element
  makeNodeComponent("explorePage"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    titleSection: makeNodeComponent("titleSection"),
    fromIdeaToProduct: makeNodeComponent("fromIdeaToProduct"),
    subtitleText: makeNodeComponent("subtitleText"),
    resourcesSection: makeNodeComponent("resourcesSection"),
    newsLetterMobile: makeNodeComponent("newsLetterMobile"),
    resourcesFilterDropdownMenu: makeNodeComponent(
      "resourcesFilterDropdownMenu"
    ),
    categoriesDropdownMenu: makeNodeComponent("categoriesDropdownMenu"),
    resourceFiltersSlotElement: makeNodeComponent("resourceFiltersSlotElement"),
    buttonLinkPrimary: makeNodeComponent("buttonLinkPrimary"),
    buttonLinkSecondary: makeNodeComponent("buttonLinkSecondary"),
    resourceList: makeNodeComponent("resourceList"),
    resourceCard: makeNodeComponent("resourceCard"),
    signupSection: makeNodeComponent("signupSection"),
    signupEmailInput: makeNodeComponent("signupEmailInput"),
    signupInput: makeNodeComponent("signupInput"),
    signupEmailButton: makeNodeComponent("signupEmailButton"),
    feedbackSection: makeNodeComponent("feedbackSection"),
    feedbackButton: makeNodeComponent("feedbackButton"),
    newsLetter: makeNodeComponent("newsLetter"),
    bottomNewsLetter: makeNodeComponent("bottomNewsLetter"),
    feedbackModal: makeNodeComponent("feedbackModal"),
    footer: makeNodeComponent("footer"),
    resourceInfoModal: makeNodeComponent("resourceInfoModal"),
    resourceModal: makeNodeComponent("resourceModal"),
    ol: makeNodeComponent("ol"),
    resourceModal2: makeNodeComponent("resourceModal2"),

    // Metadata about props expected for PlasmicExplorePage
    internalVariantProps: PlasmicExplorePage__VariantProps,
    internalArgProps: PlasmicExplorePage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicExplorePage;
/* prettier-ignore-end */
